import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * A custom hook for managing video elements
 * @returns An object containing the video ref, loading state, and handler function
 */
export default function useVideo() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const currentVideoRef = videoRef.current;

    return () => {
      if (currentVideoRef) {
        currentVideoRef.pause();
        currentVideoRef.src = '';
        currentVideoRef.load();
      }
    };
  }, []);

  const handleVideoLoaded = useCallback(() => {
    setVideoLoaded(true);
  }, []);

  return {
    videoRef,
    videoLoaded,
    handleVideoLoaded
  };
}
